const LoyaltyBannerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={20} fill="none">
    <mask
      id="a"
      width={30}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#fff" d="M.86.625h28.266v18.78H.86V.625Z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#FEFEFE"
        fillRule="evenodd"
        d="M14.994 19.405C7.2 19.405.86 13.063.86 5.27A4.65 4.65 0 0 1 5.505.625 4.65 4.65 0 0 1 10.15 5.27a4.848 4.848 0 0 0 4.844 4.841 4.847 4.847 0 0 0 4.841-4.841A4.649 4.649 0 0 1 24.478.625a4.652 4.652 0 0 1 4.648 4.645c0 7.793-6.34 14.135-14.132 14.135Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#EE4043"
      fillRule="evenodd"
      d="M24.509 2.152a3.139 3.139 0 0 0-3.136 3.135 6.42 6.42 0 0 1-6.41 6.413c-3.534 0-6.41-2.877-6.41-6.413a3.14 3.14 0 0 0-3.135-3.135 3.14 3.14 0 0 0-3.137 3.135c0 6.994 5.69 12.684 12.681 12.684 6.993 0 12.68-5.69 12.68-12.684a3.139 3.139 0 0 0-3.133-3.135Z"
      clipRule="evenodd"
    />
  </svg>
)
export { LoyaltyBannerIcon }
